
            const data = {"name":"facebook","data":{"viewBox":"0 0 512 512","data":"<path pid=\"0\" d=\"M384 3v76h-45c-17 0-28 3-33 10-6 7-9 17-9 31v54h84l-11 85h-73v216h-87V259h-73v-85h73v-62c0-36 10-63 29-83 20-19 47-29 80-29 28 0 49 1 65 3z\"/>","originalColors":[],"stopColors":[]}}
        
                    module.exports = data
                    